import React from "react";
import { colorsV2 } from "../styles/colors";

export default (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          border: "solid 1px grey",
          padding: 30,
          borderRadius: 10,
          margin: 30,
        }}
      >
        <h1 style={{ textAlign: "center", color: colorsV2.main }}>
          Invalid Link
        </h1>
        <p>
          We are sorry the link you've clicked has expired or was already used
          to submit the survey and cannot be used again.
        </p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/layout/NPSError.js